<template>
  <mdb-container fluid id="body-print">
    <section class="mb-4">
      <div class="card">
        <div class="card-body text-center">
          <h4 class="h4-responsive">
            {{invoice.InvoiceTypeName}}
          </h4>
        </div>
        <div class="card-body d-flex justify-content-between">
          <div>
            <h4 class="h4-responsive mt-3">
              شناسه فاکتور {{ invoice.Number }}
            </h4>
            <div class="alert alert-info">
              <strong>تاریخ ایجاد فاکتور : </strong>{{ invoice.FirstUpdate }}
            </div>
            <div class="alert alert-warning">
              <strong>تاریخ اعتبار پرداخت : </strong>{{ invoice.Expiration }}
            </div>
          </div>
          <div>

            <div v-show="invoice.Status == 1 && invoice.PayStatus == 0" class="alert alert-warning">
              <strong>وضعیت : </strong>{{ invoice.PayStatusName }}
            </div>

            
            <div v-show="invoice.Status != 1" class="alert alert-danger">
              <strong>وضعیت : </strong>{{ invoice.StatusName }}
            </div>

            <mdbBtn
              v-show="invoice.PayStatus == 0 && invoice.Status == 1 && (invoice.PaymentType == 0 || invoice.PaymentType == 3)"
              color="secondary"
              @click="$router.push({name: 'Request', params: { type: 'Invoice', id: invoice.InvoiceId },})"
              >ثبت فیش پرداخت</mdbBtn>

            <a
              v-show="invoice.PayStatus == 0 && invoice.Status == 1 && (invoice.PaymentType == 2 || invoice.PaymentType == 3)"
              class="btn btn-default ripple-parent"
              :href="'https://bndbs.ir/Payment/' + invoice.InvoiceId"
              >پرداخت درگاه بانکی</a>
            <div
              v-show="invoice.PayStatus == 1 && invoice.Status != 2"
              class="alert alert-success"
            >
              پرداخت با موفقت انجام شده است
            </div>
            <mdbBtn color="primary" class="d-print-none" icon="print" iconLeft @click="printInvoice"
              >پرینت</mdbBtn
            >
          </div>
        </div>
      </div>
    </section>

    <section class="mb-4">
      <div class="card">
        <div class="card-body text-center">
          <strong>
            اطلاعات فروشنده
          </strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <strong> نام شخص حقیقی / حقوقی :</strong>
              <span>شرکت برنامه نویسان دانش برتر سهند</span>
            </div>

            <div class="col-md-3">
              <strong> شماره ثبت :</strong>
              <span v-show="invoice.InvoiceType == 2">۳۵۸۹۱</span>
            </div>

            <div class="col-md-3">
              <strong> شناسه ملی شرکت :</strong>
              <span v-show="invoice.InvoiceType == 2 && invoice.PayStatus == 1">۱۰۲۰۰۴۳۸۶۷۹</span>
            </div>

            <div class="col-md-6">
              <strong> استان :</strong>
              <span v-show="invoice.InvoiceType == 2 && invoice.PayStatus == 1">آذربایجان شرقی</span>
            </div>

            <div class="col-md-3">
              <strong>شهر :</strong>
              <span v-show="invoice.InvoiceType == 2 && invoice.PayStatus == 1">تبریز</span>
            </div>

            <div class="col-md-3">
              <strong> کدپستی :</strong>
              <span v-show="invoice.InvoiceType == 2 && invoice.PayStatus == 1">۵۱۶۳۸۱۵۷۴۶</span>
            </div>

            <div class="col-md-9">
              <strong> آدرس :</strong>
              <span v-show="invoice.InvoiceType == 2 && invoice.PayStatus == 1">پاستور جدید چهارراه فدک نبش چهارراه واحد ۳</span>
            </div>

            <div class="col-md-3">
              <strong>تلفن :</strong>
              <span v-show="invoice.InvoiceType == 2 && invoice.PayStatus == 1">۳۳۳۵۳۱۹۸-۰۴۱</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mb-4">
      <div class="card">
        <div class="card-body text-center">
          <strong>
            اطلاعات خریدار
          </strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <strong> نام شخص حقیقی / حقوقی :</strong>
              <span v-show="invoice.InvoiceType == 2" v-text="invoice.Company.Name"></span>
            </div>

            <div class="col-md-3">
              <strong> شماره ثبت :</strong>
              <span v-show="invoice.InvoiceType == 2" v-text="invoice.Company.RegistrationNumber"></span>
            </div>

            <div class="col-md-3">
              <strong> شناسه ملی شرکت :</strong>
              <span v-show="invoice.InvoiceType == 2" v-text="invoice.Company.EconomicalNumber"></span>
            </div>

            <div class="col-md-6">
              <strong> استان :</strong>
              <span v-show="invoice.InvoiceType == 2" v-text="invoice.Company.Province"></span>
            </div>

            <div class="col-md-3">
              <strong>شهر :</strong>
              <span v-show="invoice.InvoiceType == 2" v-text="invoice.Company.City"></span>
            </div>

            <div class="col-md-3">
              <strong> کدپستی :</strong>
              <span v-show="invoice.InvoiceType == 2" v-text="invoice.Company.CodePost"></span>
            </div>

            <div class="col-md-9">
              <strong> آدرس :</strong>
              <span v-show="invoice.InvoiceType == 2" v-text="invoice.Company.Address"></span>
            </div>

            <div class="col-md-3">
              <strong>تلفن :</strong>
              <span v-show="invoice.InvoiceType == 2" v-text="invoice.Company.Telphone"></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mb-4">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>کد کالا</th>
                  <th>شرح کالا یا خدمات</th>
                  <th>مقدار</th>
                  <th>واحد</th>
                  <th>مبلغ واحد</th>

                  <th>مبلغ کل</th>
                  <th>مبلغ تخفیف</th>
                  <th>مبلغ كل پس از تخفیف</th>
                  <th>جمع مالیات و عوارض</th>
                  <th>جمع مبلغ نهایی</th>
                </tr>
              </thead>
              <tbody v-if="invoice.Details != null">
                <tr
                  v-for="(detil, index) in invoice.Details"
                  v-bind:key="detil.InvoiceDetailId"
                >
                  <td v-text="index + 1"></td>
                  <td v-text="detil.Code"></td>
                  <td v-text="detil.Name"></td>
                  <td v-text="detil.Count"></td>
                  <td v-text="detil.Unit"></td>
                  <td>{{ detil.Price | commaDigit }}</td>
                  <td>{{ (detil.Price * detil.Count) | commaDigit }}</td>
                  <td v-text="0"></td>
                  <td>{{ (detil.Price * detil.Count) | commaDigit }}</td>
                  <td>
                    {{
                      (detil.Price * detil.Count * detil.Taxation) | commaDigit
                    }}
                  </td>
                  <td>
                    {{
                      (detil.Price * detil.Count +
                        detil.Price * detil.Count * detil.Taxation)
                        | commaDigit
                    }}
                  </td>
                </tr>

                <tr>
                  <td colspan="6">
                    <strong>جمــع كـل قابل پرداخت: </strong>
                  </td>
                  <td>{{ totalA | commaDigit }}</td>
                  <td>0</td>
                  <td>{{ totalA | commaDigit }}</td>
                  <td>{{ totalB | commaDigit }}</td>
                  <td>{{ totalC | commaDigit }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <ul class="list-unstyled text-right">
            <li>
              <strong>توضیحات : </strong
              ><span class="float-left ml-3">{{ invoice.Descript }}</span>
            </li>
            <!-- <li>
              <strong>TAX:</strong><span class="float-right ml-3">$173,65</span>
            </li> -->
          </ul>
        </div>
      </div>
    </section>

    <section v-show="(invoice.PaymentType == 0 || invoice.PaymentType == 3) && invoice.Status == 1 ">
      <div class="card">
        <div class="card-body text-center">
          <strong>
            شماره حساب های معتبر
          </strong>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>عنوان</th>
                  <th>نام صاحب حساب</th>
                  <th>شماره حساب</th>
                  <th>شماره کارت</th>
                  <th>شماره شبا</th>
                  <th>نام بانک</th>
                </tr>
              </thead>
              <tbody>
                <tr v-show="invoice.InvoiceType != 2">
                  <td>1</td>
                  <td>مدیر پروژه شما</td>
                  <td>عباس فرشیدی</td>
                  <td>10.10924523.1</td>
                  <td>5041-7212-1131-2021</td>
                  <td>IR170700010001110924523001</td>
                  <td>بانک رسالت</td>
                </tr>
                <tr v-show="invoice.InvoiceType != 2" title="برای دسترسی با پشتیبانی تماس بگیرید">
                  <td>2</td>
                  <td>شریک تجاری شما</td>
                  <td>شرکت برنامه نویسان دانش برتر سهند</td>
                  <td class="blur">**********</td>
                  <td class="blur">****************</td>
                  <td class="blur">************************</td>
                  <td>بانک ملت</td>
                </tr>
                <tr v-show="invoice.InvoiceType == 2">
                  <td>1</td>
                  <td>شریک تجاری شما</td>
                  <td>شرکت برنامه نویسان دانش برتر سهند</td>
                  <td>8001445090</td>
                  <td>-</td>
                  <td>IR450120000000008001445090</td>
                  <td>بانک ملت</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbBtn } from "mdbvue";

// eslint-disable-next-line
Chart.defaults.global.defaultFontColor = "#fff";

import invoiceApi from "@/api/invoiceApi";

export default {
  name: "Invoice",
  components: {
    mdbContainer,
    mdbBtn,
  },
  data() {
    return {
      invoice: {},
    };
  },
  computed: {
    totalA() {
      return this.invoice.Details.reduce(
        (acc, item) => acc + Number(item.Price * item.Count),
        0
      );
    },
    totalB() {
      return this.invoice.Details.reduce(
        (acc, item) => acc + Number(item.Price * item.Count * item.Taxation),
        0
      );
    },
    totalC() {
      return this.invoice.Details.reduce(
        (acc, item) =>
          acc +
          Number(
            item.Price * item.Count + item.Price * item.Count * item.Taxation
          ),
        0
      );
    },
  },
  mounted() {
    const vueThis = this;
    let invoiceId = this.$route.params.invoiceId;

    invoiceApi.getInvoice(invoiceId).then(
      ({ data }) => {
        this.invoice = data;
        console.log(data);
      },
      (r) => {
        console.error(r);
      }
    );
  },
  methods: {
    printInvoice() {
      const prtHtml = document.getElementById("body-print").innerHTML;
      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
          <style>
          html,body{
            direction: rtl;
text-align: right;
          }
          </style>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
strong {
  font-weight: bolder;
}
.blur{
  filter: blur(4px);
}
</style>
